<template>
    <!-- scan part  -->
    <div>
        <!-- load the scan reader -->
        <div class="loader" v-if="loading">
            <img src="../../assets/img/grid_loader.svg">
        </div>
        <div id="interactive" class="viewport" v-show="!loading"></div>
        <!-- open dialog with cam -->
        <v-dialog
          v-model="dialog"
          persistent
          :overlay="false"
          max-width="500px"
        >
            <v-card class="found">
                <v-card-title class="primary">
                  <h2 class="white--text">
                      <v-icon dark class="mr-2">mdi-barcode</v-icon>
                      <span>Redirection</span>
                  </h2>
                </v-card-title>
                <v-card-text>
                    <img src="../../assets/img/grid_loader.svg">
                    <p class="mt-2">Vous allez être redirigé sur la fiche ...</p>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Quagga from 'quagga';
    export default {
        compoenents: {
            Quagga
        },
        data() {
            return {
                title:          'Scanner un codebar',
                icon:           'mdi-barcode',
                dialog:         false,
                loading:        false,
            }
        },

        methods: {
            onClose() {
                Quagga.stop()
                this.$eventHub.$emit('close-modal')
            },
            // init the barcode reader plugin
            init_quagga(){
                let _this = this;
                Quagga.init(
                  {
                      inputStream : {
                         name : "Live",
                         type : "LiveStream",
                         target: document.querySelector('#interactive')    // Or '#yourElement' (optional)
                       },
                       decoder : {
                         readers : ["ean_reader"],
                         debug: {
                            drawBoundingBox: false,
                            showFrequency: false,
                            drawScanline: false,
                            showPattern: false,
                          },
                          multiple: false
                       },
                       locator: {
                          patchSize: "large", // x-small, small, medium, large, x-large
                       },
                       constraints: {
                          width: 640,
                          height: 480,
                          facingMode: { exact: "environment" },
                          aspectRatio: {min: 1, max: 100},
                          deviceId: _this.backCamID
                      },
                      area: {
                          // defines rectangle of the detection/localization area
                          top: "0%", // top offset
                          right: "0%", // right offset
                          left: "0%", // left offset
                          bottom: "0%" // bottom offset
                      },
                      singleChannel: false // true: only the red color-channel is read
                     }, function(err) {
                         if (err) {
                             console.log(err);
                             return
                         }
                         _this.loading = false
                         Quagga.start();
                     }
                 );

                  Quagga.onProcessed(function(result) {
                      let drawingCtx = Quagga.canvas.ctx.overlay,
                      drawingCanvas = Quagga.canvas.dom.overlay;

                      if (result) {
                          if (result.boxes) {
                              drawingCtx.clearRect(
                                  0,
                                  0,
                                  parseInt(drawingCanvas.getAttribute("width")),
                                  parseInt(drawingCanvas.getAttribute("height"))
                              );
                              result.boxes
                                  .filter(function(box) {
                                  return box !== result.box;
                                  })
                                  .forEach(function(box) {
                                  Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                                      color: "green",
                                      lineWidth: 2
                                  });
                                  });
                              }

                          if (result.box) {
                              Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
                                  color: "#00F",
                                  lineWidth: 2
                              });
                          }

                          if (result.codeResult && result.codeResult.code) {
                              Quagga.ImageDebug.drawPath(
                                  result.line,
                                  { x: "x", y: "y" },
                                  drawingCtx,
                                  { color: "red", lineWidth: 3 }
                              );
                          }
                      }
                  });
                    // when barcode is detected
                  Quagga.onDetected(function(result) {
                      if(result.codeResult.code){
                          //get the code of the barcode
                          let code = result.codeResult.code
                           _this.dialog = true
                           //debouce fonction -- check if the code exist
                           _this.debounceInput(code)
                      }
                  });
            },

            debounceInput: _.debounce(function (code) {
                if (code) {
                    //get request to check if the code exist
                    this.axios.get(`/api/products?filters=ean|=|${code}`)
                    .then(response => {
                        if(response.data[0]){
                            // if exist stop the reader, close the modal and open single product page
                            Quagga.stop()
                            this.$router.push({name:'single-product', params:{super_family:response.data[0].group,id:response.data[0].id}})
                            this.$eventHub.$emit('close-modal')
                        } else {
                            // else open an error snackbar that tell the code doesn't exist
                            this.$eventHub.$emit('open-snackbar','error','code bar non trouvé, veuillé réessayer')
                            this.dialog = false
                        }
                    })
                }
            }, 200)
        },
        created() {
           let _this = this;
           // alert(navigator.mediaDevices)
           if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
               // alert("Doesn't work");
               return;

               navigator.mediaDevices.enumerateDevices()
               .then(function(devices) {
                   devices.forEach(function(device) {
                       // alert( JSON.stringify(device) );
                       if( device.kind == "videoinput" && device.label.match(/back/) != null ){
                           // alert("Back found!");
                           _this.backCamID = device.deviceId;
                           // console.log("device id", device)
                           // alert("backCamID", _this.backCamID);
                       }
                   });
               })
               .catch(function(err) {
                   alert("Error");
               });

               if(_this.backCamID == null){
                       _this.backCamID = ""; // fallback value
                       // console.log("backCamID is null")
                   }
           }
       },
       mounted() {
         this.loading = true
         this.$eventHub.$emit('hide-modal-actions')
         if(document.querySelector('#interactive')) {
            this.init_quagga()
         }
    }
}
</script>

<style lang="stylus" scoped>
div#interactive {
    padding: 1rem 4rem
    position: relative
    & >>> canvas.drawingBuffer {
        position: absolute
        top:1rem
    }
}
.found {
    .card__title {
        h2 {
            display: flex
            align-items: center
        }
    }
    .card__text {
        display: flex
        align-items: center
        flex-direction: column
        img {
            padding: 3rem
        }
    }
}
.loader {
    display: flex
    align-items: center
    justify-content: center
}
</style>



// WEBPACK FOOTER //
// src/layouts/app/Scan.vue